import posthog from "posthog-js";

import { setPostHogSessionCookie } from "@/app/actions/signup-source";

/**
 * Persist the current PostHog browser session id in a cookie right before a
 * social sign-in, so the server-side signup_completed event (Better Auth
 * user.create.after hook, which is outside tRPC) can attach $session_id and
 * link to the session recording.
 *
 * Call from every signup entry point: /join (ExpertSignIn) and the apply-flow
 * auth screen (RecruitmentAuthScreen). get_session_id() is client-only, which
 * is why the value is captured here and relayed via the cookie across the
 * OAuth redirect.
 */
export async function persistPostHogSessionForSignup(): Promise<void> {
  try {
    await setPostHogSessionCookie(posthog.get_session_id() ?? undefined);
  } catch {
    // posthog-js not initialized yet; skip; signup_completed simply won't
    // carry $session_id for this attempt.
  }
}
